// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"2943259a","239":"ef842590","382":"9e0f09de","453":"8a24bcf0","455":"8c8c6869","568":"3cc3301e","977":"6b59ee80"}[chunkId] + ".chunk.js";
};